import BaseObject from './base_object';
import _ from '../utils/underscore';

export default class BaseSingleton extends BaseObject {

    static $instance = null;


    static create(params?: any): any {
        if (!_.isNull(this.$instance)) {
            return this.$instance;
        }

        this.$instance = super.create(params);

        return this.$instance;
    }

    /**
     * This method is mainly used in unit testing
     * in order to create a fresh instance on every test run
     */
     static reCreate(params?: any): any {
         this.$instance = null;
         return this.create(params);
    }
}

